/*
* Copyright (C) Regione Lombardia
*/
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import { DialogMessage, DialogMessageLevel } from '@models';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UtilsService } from '@shared/services/utils.service';

@Component({
    selector: 'app-layout-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
})
export class LayoutDialogComponent implements OnInit {

    @ViewChild('dialogMessageModal') dialogMessageModal: TemplateRef<any> | undefined;

    public messages: DialogMessage[] = [];
    private modale: NgbModalRef | undefined;

    constructor(
        private utilService: UtilsService,
        private modalService: NgbModal,
    ) { }

    ngOnInit() {
        this.utilService.messages$.subscribe((message: DialogMessage | null) =>
            this.addDialogMessage(message)
        );
    }

    private addDialogMessage(dialogMessage: DialogMessage | null) {
        if (!dialogMessage) {
            this.resetDialogMessage();
            return;
        }
        /* se il messaggio e' duplicato non lo aggiungo */
        const messages = this.messages.filter(m =>
            m.level === dialogMessage.level &&
            m.message === dialogMessage.message
        );
        if (!messages.length) {
            this.messages.push(this.parseDialogMessage(dialogMessage));
            if (!this.modale) {
                this.modale = this.modalService.open(this.dialogMessageModal);
                this.modale.result.then((result) => {
                    this.resetDialogMessage();
                }, (reason) => {
                    this.resetDialogMessage();
                });
            }
        }
    }

    private parseDialogMessage(dialogMessage: DialogMessage) {
        switch (dialogMessage.level) {
            case DialogMessageLevel.SUCCESS:
                return {
                    ...dialogMessage,
                    icon: 'check-circle',
                    title: CoreI18nConfigs.messages.dialogSuccess,
                    iconClassName: 'icon icon-sm icon-success',
                    className: 'text-success'
                };
            case DialogMessageLevel.ERROR:
                return {
                    ...dialogMessage,
                    icon: 'error',
                    title: CoreI18nConfigs.messages.dialogError,
                    iconClassName: 'icon icon-sm icon-danger',
                    className: 'text-danger'
                };
            case DialogMessageLevel.WARNING:
                return {
                    ...dialogMessage,
                    icon: 'error',
                    title: CoreI18nConfigs.messages.dialogWarning,
                    iconClassName: 'icon icon-sm icon-warning',
                    className: 'text-warning',
                };
            default:
                return {
                    ...dialogMessage,
                    icon: 'info-circle',
                    title: CoreI18nConfigs.messages.dialogInfo,
                    iconClassName: 'icon icon-sm icon-info',
                    className: 'text-info',
                };
        }
    }

    private resetDialogMessage() {
        this.messages = [];
        this.modale = undefined;
    }

    public closeModal() {
        this.modale && this.modale.close();
    }

}
